<a (click)="open()" class="tw:no-underline! tw:cursor-pointer">
	<div
		class="tw:flex tw:items-center tw:p-2 tw:ps-0 tw:font-medium tw:text-sm tw:text-secondary tw:hover:bg-[#F5F5F5] tw:group"
		[ngClass]="{ 'tw:bg-[#F5F5F5] active': !isCollapsed }"
	>
		<div
			class="tw:hidden tw:[.active_&]:block! tw:w-1 tw:h-6 tw:rounded-tr-2xl tw:rounded-br-2xl"
			[ngClass]="{
				'tw:bg-primary': !isInternalView,
				'tw:bg-purple': isInternalView,
			}"
		></div>

		<mat-icon
			class="mx-2"
			[ngClass]="{
				'tw:group-hover:text-primary! tw:[.active_&]:text-primary!': !isInternalView,
				'tw:group-hover:text-purple! tw:[.active_&]:text-purple!': isInternalView,
			}"
		>
			{{ icon() }}
		</mat-icon>

		<span
			class="tw:grow tw:group-hover:text-default tw:group-hover:font-semibold tw:[.active_&]:text-default tw:[.active_&]:font-semibold"
		>
			<ng-content></ng-content>
		</span>

		@if (hasSubMenu()) {
			<mat-icon
				class="mx-2"
				[ngClass]="{
					'tw:group-hover:text-primary! tw:[.active_&]:text-primary': !isInternalView,
					'tw:group-hover:text-purple! tw:[.active_&]:text-purple': isInternalView,
				}"
			>
				stat_minus_1
			</mat-icon>
		}
	</div>
</a>

<div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed" class="tw:p-1">
	<ng-content select="z-sub-menu"></ng-content>
</div>
